export default __webpack_public_path__ + "static/media/gameHistorySelected.def117ac.svg";